
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexJ_oA9UKbwBRnpuzvA5YZCls_lI_45Z61539mwffhh5npcMeta } from "/codebuild/output/src863075979/src/storefront/pages/index.vue?macro=true";
import { default as loginZg2MvtHWIPHj7avXjp_ahux2KdK92YSy9qAI7oQd6YEMeta } from "/codebuild/output/src863075979/src/storefront/pages/login.vue?macro=true";
import { default as cookieZifAHaIe9WhjJzxNcJrUTQHwmYdklwkAzv548V_Dog0Meta } from "/codebuild/output/src863075979/src/storefront/pages/cookie.vue?macro=true";
import { default as searchT5oxDfvienAsyUj4hK9hPCFnKeAP_iJbEL24zCyk_45rcMeta } from "/codebuild/output/src863075979/src/storefront/pages/search.vue?macro=true";
import { default as my_45cartkkFkTpIfShokeGVf8kqvRZSRUuC9PFamVBxLMpqP1AoMeta } from "/codebuild/output/src863075979/src/storefront/pages/my-cart.vue?macro=true";
import { default as on_45saleb5t_BvYbNvpmK9mfCwu3tjfz96QghKdqSGD9nU_459jEEMeta } from "/codebuild/output/src863075979/src/storefront/pages/on-sale.vue?macro=true";
import { default as about_45usfsdFS4trWx0uSFTJGVBeGA95JVTFlOuxW3wzMSYUrz0Meta } from "/codebuild/output/src863075979/src/storefront/pages/about-us.vue?macro=true";
import { default as book_45clubgJzcvsnLPu2EXIn317oCjNaHpQntb58ggqMmfCZkILEMeta } from "/codebuild/output/src863075979/src/storefront/pages/book-club.vue?macro=true";
import { default as contact_45us0vJVq79ZM6HI688Ls5b_uo9_45rYJQYIylHky708yXETkMeta } from "/codebuild/output/src863075979/src/storefront/pages/contact-us.vue?macro=true";
import { default as newspapersJnLsqkiudiwrOchIWS6YIRxwIxwS0w3nsOlTtgpgX54Meta } from "/codebuild/output/src863075979/src/storefront/pages/newspapers.vue?macro=true";
import { default as _91slug_93e3M8z6sneyciMSRzA9tUKsa3SovdSiBXd6w2tPrWarsMeta } from "/codebuild/output/src863075979/src/storefront/pages/book/[slug].vue?macro=true";
import { default as indexXq7B0mQFC1LAU8l312FadyrX5D_45iAbKzeBrz2mb_45ttYMeta } from "/codebuild/output/src863075979/src/storefront/pages/books/index.vue?macro=true";
import { default as barion_45startEBURwcp5PEoHtWgwOg26jxdJJITcH2siyuClHWhYC4AMeta } from "/codebuild/output/src863075979/src/storefront/pages/barion-start.vue?macro=true";
import { default as paypal_45startv5qJ4wYHfrIUscDapnTvrp7DuV1CV0qTKAg7wptE80QMeta } from "/codebuild/output/src863075979/src/storefront/pages/paypal-start.vue?macro=true";
import { default as _91_46_46_46catchAll_939hAUB9lB94xfwacbZjFbHrc2pKqU4VLS1U693M40tzMMeta } from "/codebuild/output/src863075979/src/storefront/pages/[...catchAll].vue?macro=true";
import { default as indexXbNiCLR88piFFtc3oE1ZcTVFHICZukLxwwWGiJ1TrIsMeta } from "/codebuild/output/src863075979/src/storefront/pages/checkout/index.vue?macro=true";
import { default as payment_45resultmlh_FA6cdYzkzxUXzMm0AcF3_45evqDFcf2zL4jVLY9J4Meta } from "/codebuild/output/src863075979/src/storefront/pages/payment-result.vue?macro=true";
import { default as privacy_45policyRZNT2fr09cPg7wop3b3FwkvN_LYk0Iv4Vm2g_vJQUD8Meta } from "/codebuild/output/src863075979/src/storefront/pages/privacy-policy.vue?macro=true";
import { default as indexNScYh2X5oh1NWdV6u3H_453HFx3XBMV_0ROR9cGX6HSC4Meta } from "/codebuild/output/src863075979/src/storefront/pages/my-orders/index.vue?macro=true";
import { default as newly_45publishedpvAwDkTaF982_4536oDSJZOf_45fH4v86UKuw9VcUppLUSkMeta } from "/codebuild/output/src863075979/src/storefront/pages/newly-published.vue?macro=true";
import { default as _91slug_93wWzyrskzT4YHXGrKUGQcfGvH1Vn6e60Q9NeT_pUc0SQMeta } from "/codebuild/output/src863075979/src/storefront/pages/my-orders/[slug].vue?macro=true";
import { default as thankyou1JCjFUFrcqNRdrT19cXDf2jyPtyZOov9uynVuzSCE_45wMeta } from "/codebuild/output/src863075979/src/storefront/pages/checkout/thankyou.vue?macro=true";
import { default as upcoming_45releasesWuwp_KBZyjKRY6kBiuFUfKAhGx0YkQm_45wwhcn_45KtXuQMeta } from "/codebuild/output/src863075979/src/storefront/pages/upcoming-releases.vue?macro=true";
import { default as terms_45and_45conditions72JReTP_f3IaQAbM_45WJ77sozIeGht0o4cqIseGSTrgUMeta } from "/codebuild/output/src863075979/src/storefront/pages/terms-and-conditions.vue?macro=true";
import { default as _91slug_93PfxcpuwFqgOwNYltohUCtLIguVUQC6xZOXyZl5IOjH4Meta } from "/codebuild/output/src863075979/src/storefront/pages/other-language/[slug].vue?macro=true";
import { default as indexnHMnvYkWk_45uJ_4501R2sOEB8PGfkqSE0Hc_45VmmnqtRL7AMeta } from "/codebuild/output/src863075979/src/storefront/pages/other-languages/index.vue?macro=true";
import { default as staff_45recommendationsSNjgIxBIJNmt0ttp8_45Fa0WziGzYVqDy2mgOhxNKfuwEMeta } from "/codebuild/output/src863075979/src/storefront/pages/staff-recommendations.vue?macro=true";
import { default as _91slug_93F_45bQ_CTsdOT_45f4Z9lbPx4jygyuMoEUfH6siiJA4QAlEMeta } from "/codebuild/output/src863075979/src/storefront/pages/books-by-author/[slug].vue?macro=true";
import { default as indexX7bqnTkx3lhLLUREElA_CZr43M_7cecyYDGIFV0EwQIMeta } from "/codebuild/output/src863075979/src/storefront/pages/books/[category]/index.vue?macro=true";
import { default as _91slug_93sfHXd5YCpT8_45kYQbHAk1Tvn1h_45GY49YzOQpW_OOHPg4Meta } from "/codebuild/output/src863075979/src/storefront/pages/menu-navigation/[slug].vue?macro=true";
import { default as bestsellers_45of_45the_45monthUoYPzzFB1RDg1MQdrrrCJi4WlGgeRfmikaTHwTSfjJ0Meta } from "/codebuild/output/src863075979/src/storefront/pages/bestsellers-of-the-month.vue?macro=true";
import { default as _91slug_93ummZPIcSry_45GGZj3cTZbJ0bx8MjjmNlrorEO5qlEyWoMeta } from "/codebuild/output/src863075979/src/storefront/pages/stationary-and-gift/[slug].vue?macro=true";
import { default as indexLWpFbdjKJX8taIh79yVTt3E7H3sBb8X8evjtBGr8EGcMeta } from "/codebuild/output/src863075979/src/storefront/pages/stationary-and-gifts/index.vue?macro=true";
import { default as indexpWl8PdS0f31gaXV4VQBFern4FquKSYSW9HrvVW3_mWIMeta } from "/codebuild/output/src863075979/src/storefront/pages/other-languages/[category]/index.vue?macro=true";
import { default as purchase_45and_45shipping_45conditionsdw19_45wyT3WUbjKv5OrzRYMTC1gt34s1m2RSH3SIdP4cMeta } from "/codebuild/output/src863075979/src/storefront/pages/purchase-and-shipping-conditions.vue?macro=true";
import { default as indexspGKEKmY4OP6UWaRGHi0E1aZ_455GtNavL_jDi2eMxF7UMeta } from "/codebuild/output/src863075979/src/storefront/pages/books/[category]/[subcategory]/index.vue?macro=true";
import { default as _91_91subcategory_93_930T5NLh4hT6bo5husWJdpauvPaizDmmTvdynKzT6szIMMeta } from "/codebuild/output/src863075979/src/storefront/pages/products/[[category]]/[[subcategory]].vue?macro=true";
import { default as indexxJ0It6Ol_45vwE7rEXi0Y_oHeF4uR02b0tCw_45lyQr8LbQMeta } from "/codebuild/output/src863075979/src/storefront/pages/stationary-and-gifts/[category]/index.vue?macro=true";
import { default as indexokw9koJ6d0FwnPxkCTqWLILFB9UGxuln_xzfdlzESTUMeta } from "/codebuild/output/src863075979/src/storefront/pages/other-languages/[category]/[subcategory]/index.vue?macro=true";
import { default as indexQbRsIMtwe8t7RtAhqHVl70hpN2jkahsxxVhDEfOX9QAMeta } from "/codebuild/output/src863075979/src/storefront/pages/stationary-and-gifts/[category]/[subcategory]/index.vue?macro=true";
export default [
  {
    name: "index___hu",
    path: "/hu",
    meta: indexJ_oA9UKbwBRnpuzvA5YZCls_lI_45Z61539mwffhh5npcMeta || {},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/",
    meta: indexJ_oA9UKbwBRnpuzvA5YZCls_lI_45Z61539mwffhh5npcMeta || {},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/index.vue")
  },
  {
    name: "login___hu",
    path: "/hu/bejelentkezes",
    meta: {"middleware":"auth"},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/login.vue")
  },
  {
    name: "login___en",
    path: "/login",
    meta: {"middleware":"auth"},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/login.vue")
  },
  {
    name: "cookie___hu",
    path: "/hu/suti",
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/cookie.vue")
  },
  {
    name: "cookie___en",
    path: "/cookie",
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/cookie.vue")
  },
  {
    name: "search___hu",
    path: "/hu/kereses",
    meta: searchT5oxDfvienAsyUj4hK9hPCFnKeAP_iJbEL24zCyk_45rcMeta || {},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/search.vue")
  },
  {
    name: "search___en",
    path: "/search",
    meta: searchT5oxDfvienAsyUj4hK9hPCFnKeAP_iJbEL24zCyk_45rcMeta || {},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/search.vue")
  },
  {
    name: "my-cart___hu",
    path: "/hu/kosaram",
    meta: my_45cartkkFkTpIfShokeGVf8kqvRZSRUuC9PFamVBxLMpqP1AoMeta || {},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/my-cart.vue")
  },
  {
    name: "my-cart___en",
    path: "/my-cart",
    meta: my_45cartkkFkTpIfShokeGVf8kqvRZSRUuC9PFamVBxLMpqP1AoMeta || {},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/my-cart.vue")
  },
  {
    name: "on-sale___hu",
    path: "/hu/akciok",
    meta: on_45saleb5t_BvYbNvpmK9mfCwu3tjfz96QghKdqSGD9nU_459jEEMeta || {},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/on-sale.vue")
  },
  {
    name: "on-sale___en",
    path: "/on-sale",
    meta: on_45saleb5t_BvYbNvpmK9mfCwu3tjfz96QghKdqSGD9nU_459jEEMeta || {},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/on-sale.vue")
  },
  {
    name: "about-us___hu",
    path: "/hu/rolunk",
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/about-us.vue")
  },
  {
    name: "about-us___en",
    path: "/about-us",
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/about-us.vue")
  },
  {
    name: "book-club___hu",
    path: "/hu/konyvklub",
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/book-club.vue")
  },
  {
    name: "book-club___en",
    path: "/book-club",
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/book-club.vue")
  },
  {
    name: "contact-us___hu",
    path: "/hu/kapcsolat",
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/contact-us.vue")
  },
  {
    name: "contact-us___en",
    path: "/contact-us",
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/contact-us.vue")
  },
  {
    name: "newspapers___hu",
    path: "/hu/ujsagok-es-magazinok",
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/newspapers.vue")
  },
  {
    name: "newspapers___en",
    path: "/newspapers-and-magazines",
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/newspapers.vue")
  },
  {
    name: "book-slug___hu",
    path: "/hu/konyv/:slug()",
    meta: _91slug_93e3M8z6sneyciMSRzA9tUKsa3SovdSiBXd6w2tPrWarsMeta || {},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/book/[slug].vue")
  },
  {
    name: "book-slug___en",
    path: "/book/:slug()",
    meta: _91slug_93e3M8z6sneyciMSRzA9tUKsa3SovdSiBXd6w2tPrWarsMeta || {},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/book/[slug].vue")
  },
  {
    name: "books___hu",
    path: "/hu/konyvek",
    meta: indexXq7B0mQFC1LAU8l312FadyrX5D_45iAbKzeBrz2mb_45ttYMeta || {},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/books/index.vue")
  },
  {
    name: "books___en",
    path: "/books",
    meta: indexXq7B0mQFC1LAU8l312FadyrX5D_45iAbKzeBrz2mb_45ttYMeta || {},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/books/index.vue")
  },
  {
    name: "barion-start___hu",
    path: "/hu/barion-fizetes",
    meta: { ...(barion_45startEBURwcp5PEoHtWgwOg26jxdJJITcH2siyuClHWhYC4AMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/barion-start.vue")
  },
  {
    name: "barion-start___en",
    path: "/barion-start",
    meta: { ...(barion_45startEBURwcp5PEoHtWgwOg26jxdJJITcH2siyuClHWhYC4AMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/barion-start.vue")
  },
  {
    name: "paypal-start___hu",
    path: "/hu/paypal-fizetes",
    meta: { ...(paypal_45startv5qJ4wYHfrIUscDapnTvrp7DuV1CV0qTKAg7wptE80QMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/paypal-start.vue")
  },
  {
    name: "paypal-start___en",
    path: "/paypal-start",
    meta: { ...(paypal_45startv5qJ4wYHfrIUscDapnTvrp7DuV1CV0qTKAg7wptE80QMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/paypal-start.vue")
  },
  {
    name: "catchAll___hu",
    path: "/hu/:catchAll(.*)*",
    meta: _91_46_46_46catchAll_939hAUB9lB94xfwacbZjFbHrc2pKqU4VLS1U693M40tzMMeta || {},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/[...catchAll].vue")
  },
  {
    name: "catchAll___en",
    path: "/:catchAll(.*)*",
    meta: _91_46_46_46catchAll_939hAUB9lB94xfwacbZjFbHrc2pKqU4VLS1U693M40tzMMeta || {},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/[...catchAll].vue")
  },
  {
    name: "checkout___hu",
    path: "/hu/megrendeles",
    meta: { ...(indexXbNiCLR88piFFtc3oE1ZcTVFHICZukLxwwWGiJ1TrIsMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/checkout/index.vue")
  },
  {
    name: "checkout___en",
    path: "/checkout",
    meta: { ...(indexXbNiCLR88piFFtc3oE1ZcTVFHICZukLxwwWGiJ1TrIsMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/checkout/index.vue")
  },
  {
    name: "payment-result___hu",
    path: "/hu/barion-eredmeny",
    meta: { ...(payment_45resultmlh_FA6cdYzkzxUXzMm0AcF3_45evqDFcf2zL4jVLY9J4Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/payment-result.vue")
  },
  {
    name: "payment-result___en",
    path: "/barion-result",
    meta: { ...(payment_45resultmlh_FA6cdYzkzxUXzMm0AcF3_45evqDFcf2zL4jVLY9J4Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/payment-result.vue")
  },
  {
    name: "privacy-policy___hu",
    path: "/hu/adatkezelesi-tajekoztato",
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___en",
    path: "/privacy-policy",
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/privacy-policy.vue")
  },
  {
    name: "my-orders___hu",
    path: "/hu/rendeleseim",
    meta: {"middleware":["auth"]},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/my-orders/index.vue")
  },
  {
    name: "my-orders___en",
    path: "/my-orders",
    meta: {"middleware":["auth"]},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/my-orders/index.vue")
  },
  {
    name: "newly-published___hu",
    path: "/hu/ujdonsagok",
    meta: newly_45publishedpvAwDkTaF982_4536oDSJZOf_45fH4v86UKuw9VcUppLUSkMeta || {},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/newly-published.vue")
  },
  {
    name: "newly-published___en",
    path: "/newly-published",
    meta: newly_45publishedpvAwDkTaF982_4536oDSJZOf_45fH4v86UKuw9VcUppLUSkMeta || {},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/newly-published.vue")
  },
  {
    name: "my-orders-slug___hu",
    path: "/hu/rendeleseim/:slug()",
    meta: {"middleware":["auth"]},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/my-orders/[slug].vue")
  },
  {
    name: "my-orders-slug___en",
    path: "/my-orders/:slug()",
    meta: {"middleware":["auth"]},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/my-orders/[slug].vue")
  },
  {
    name: "checkout-thankyou___hu",
    path: "/hu/megrendeles-koszonjuk",
    meta: thankyou1JCjFUFrcqNRdrT19cXDf2jyPtyZOov9uynVuzSCE_45wMeta || {},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/checkout/thankyou.vue")
  },
  {
    name: "checkout-thankyou___en",
    path: "/checkout-thankyou",
    meta: thankyou1JCjFUFrcqNRdrT19cXDf2jyPtyZOov9uynVuzSCE_45wMeta || {},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/checkout/thankyou.vue")
  },
  {
    name: "upcoming-releases___hu",
    path: "/hu/varhato-megjelenesek",
    meta: upcoming_45releasesWuwp_KBZyjKRY6kBiuFUfKAhGx0YkQm_45wwhcn_45KtXuQMeta || {},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/upcoming-releases.vue")
  },
  {
    name: "upcoming-releases___en",
    path: "/upcoming-releases",
    meta: upcoming_45releasesWuwp_KBZyjKRY6kBiuFUfKAhGx0YkQm_45wwhcn_45KtXuQMeta || {},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/upcoming-releases.vue")
  },
  {
    name: "terms-and-conditions___hu",
    path: "/hu/altalanos-szerzodesi-feltetelek",
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/terms-and-conditions.vue")
  },
  {
    name: "terms-and-conditions___en",
    path: "/terms-and-conditions",
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/terms-and-conditions.vue")
  },
  {
    name: "other-language-slug___hu",
    path: "/hu/egyeb-idegen-nyelvu-konyv/:slug()",
    meta: _91slug_93PfxcpuwFqgOwNYltohUCtLIguVUQC6xZOXyZl5IOjH4Meta || {},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/other-language/[slug].vue")
  },
  {
    name: "other-language-slug___en",
    path: "/other-language/:slug()",
    meta: _91slug_93PfxcpuwFqgOwNYltohUCtLIguVUQC6xZOXyZl5IOjH4Meta || {},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/other-language/[slug].vue")
  },
  {
    name: "other-languages___hu",
    path: "/hu/egyeb-idegen-nyelvu-konyvek",
    meta: indexnHMnvYkWk_45uJ_4501R2sOEB8PGfkqSE0Hc_45VmmnqtRL7AMeta || {},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/other-languages/index.vue")
  },
  {
    name: "other-languages___en",
    path: "/other-languages",
    meta: indexnHMnvYkWk_45uJ_4501R2sOEB8PGfkqSE0Hc_45VmmnqtRL7AMeta || {},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/other-languages/index.vue")
  },
  {
    name: "staff-recommendations___hu",
    path: "/hu/mi-ajanljuk",
    meta: staff_45recommendationsSNjgIxBIJNmt0ttp8_45Fa0WziGzYVqDy2mgOhxNKfuwEMeta || {},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/staff-recommendations.vue")
  },
  {
    name: "staff-recommendations___en",
    path: "/staff-recommendations",
    meta: staff_45recommendationsSNjgIxBIJNmt0ttp8_45Fa0WziGzYVqDy2mgOhxNKfuwEMeta || {},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/staff-recommendations.vue")
  },
  {
    name: "books-by-author-slug___hu",
    path: "/hu/szerzo-muvei/:slug()",
    meta: _91slug_93F_45bQ_CTsdOT_45f4Z9lbPx4jygyuMoEUfH6siiJA4QAlEMeta || {},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/books-by-author/[slug].vue")
  },
  {
    name: "books-by-author-slug___en",
    path: "/books-by-author/:slug()",
    meta: _91slug_93F_45bQ_CTsdOT_45f4Z9lbPx4jygyuMoEUfH6siiJA4QAlEMeta || {},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/books-by-author/[slug].vue")
  },
  {
    name: "books-category___hu",
    path: "/hu/konyvek/:category()",
    meta: indexX7bqnTkx3lhLLUREElA_CZr43M_7cecyYDGIFV0EwQIMeta || {},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/books/[category]/index.vue")
  },
  {
    name: "books-category___en",
    path: "/books/:category()",
    meta: indexX7bqnTkx3lhLLUREElA_CZr43M_7cecyYDGIFV0EwQIMeta || {},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/books/[category]/index.vue")
  },
  {
    name: "menu-navigation-slug___hu",
    path: "/hu/menu-navigacio/:slug()",
    meta: _91slug_93sfHXd5YCpT8_45kYQbHAk1Tvn1h_45GY49YzOQpW_OOHPg4Meta || {},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/menu-navigation/[slug].vue")
  },
  {
    name: "menu-navigation-slug___en",
    path: "/menu-navigation/:slug()",
    meta: _91slug_93sfHXd5YCpT8_45kYQbHAk1Tvn1h_45GY49YzOQpW_OOHPg4Meta || {},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/menu-navigation/[slug].vue")
  },
  {
    name: "bestsellers-of-the-month___hu",
    path: "/hu/a-honap-sikerkonyvei",
    meta: bestsellers_45of_45the_45monthUoYPzzFB1RDg1MQdrrrCJi4WlGgeRfmikaTHwTSfjJ0Meta || {},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/bestsellers-of-the-month.vue")
  },
  {
    name: "bestsellers-of-the-month___en",
    path: "/bestsellers-of-the-month",
    meta: bestsellers_45of_45the_45monthUoYPzzFB1RDg1MQdrrrCJi4WlGgeRfmikaTHwTSfjJ0Meta || {},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/bestsellers-of-the-month.vue")
  },
  {
    name: "stationary-and-gift-slug___hu",
    path: "/hu/notesz-es-ajandektargy/:slug()",
    meta: _91slug_93ummZPIcSry_45GGZj3cTZbJ0bx8MjjmNlrorEO5qlEyWoMeta || {},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/stationary-and-gift/[slug].vue")
  },
  {
    name: "stationary-and-gift-slug___en",
    path: "/stationary-and-gift/:slug()",
    meta: _91slug_93ummZPIcSry_45GGZj3cTZbJ0bx8MjjmNlrorEO5qlEyWoMeta || {},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/stationary-and-gift/[slug].vue")
  },
  {
    name: "stationary-and-gifts___hu",
    path: "/hu/noteszek-es-ajandektargyak",
    meta: indexLWpFbdjKJX8taIh79yVTt3E7H3sBb8X8evjtBGr8EGcMeta || {},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/stationary-and-gifts/index.vue")
  },
  {
    name: "stationary-and-gifts___en",
    path: "/stationary-and-gifts",
    meta: indexLWpFbdjKJX8taIh79yVTt3E7H3sBb8X8evjtBGr8EGcMeta || {},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/stationary-and-gifts/index.vue")
  },
  {
    name: "other-languages-category___hu",
    path: "/hu/egyeb-idegen-nyelvu-konyvek/:category()",
    meta: indexpWl8PdS0f31gaXV4VQBFern4FquKSYSW9HrvVW3_mWIMeta || {},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/other-languages/[category]/index.vue")
  },
  {
    name: "other-languages-category___en",
    path: "/other-languages/:category()",
    meta: indexpWl8PdS0f31gaXV4VQBFern4FquKSYSW9HrvVW3_mWIMeta || {},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/other-languages/[category]/index.vue")
  },
  {
    name: "purchase-and-shipping-conditions___hu",
    path: "/hu/vasarlasi-es-szallitasi-feltetelek",
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/purchase-and-shipping-conditions.vue")
  },
  {
    name: "purchase-and-shipping-conditions___en",
    path: "/purchase-and-shipping-conditions",
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/purchase-and-shipping-conditions.vue")
  },
  {
    name: "books-category-subcategory___hu",
    path: "/hu/konyvek/:category()/:subcategory()",
    meta: indexspGKEKmY4OP6UWaRGHi0E1aZ_455GtNavL_jDi2eMxF7UMeta || {},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/books/[category]/[subcategory]/index.vue")
  },
  {
    name: "books-category-subcategory___en",
    path: "/books/:category()/:subcategory()",
    meta: indexspGKEKmY4OP6UWaRGHi0E1aZ_455GtNavL_jDi2eMxF7UMeta || {},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/books/[category]/[subcategory]/index.vue")
  },
  {
    name: "products-category-subcategory___hu",
    path: "/hu/product/:category?/:subcategory?",
    meta: _91_91subcategory_93_930T5NLh4hT6bo5husWJdpauvPaizDmmTvdynKzT6szIMMeta || {},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/products/[[category]]/[[subcategory]].vue")
  },
  {
    name: "products-category-subcategory___en",
    path: "/products/:category?/:subcategory?",
    meta: _91_91subcategory_93_930T5NLh4hT6bo5husWJdpauvPaizDmmTvdynKzT6szIMMeta || {},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/products/[[category]]/[[subcategory]].vue")
  },
  {
    name: "stationary-and-gifts-category___hu",
    path: "/hu/noteszek-es-ajandektargyak/:category()",
    meta: indexxJ0It6Ol_45vwE7rEXi0Y_oHeF4uR02b0tCw_45lyQr8LbQMeta || {},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/stationary-and-gifts/[category]/index.vue")
  },
  {
    name: "stationary-and-gifts-category___en",
    path: "/stationary-and-gifts/:category()",
    meta: indexxJ0It6Ol_45vwE7rEXi0Y_oHeF4uR02b0tCw_45lyQr8LbQMeta || {},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/stationary-and-gifts/[category]/index.vue")
  },
  {
    name: "other-languages-category-subcategory___hu",
    path: "/hu/egyeb-idegen-nyelvu-konyvek/:categorysubcategory?",
    meta: indexokw9koJ6d0FwnPxkCTqWLILFB9UGxuln_xzfdlzESTUMeta || {},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/other-languages/[category]/[subcategory]/index.vue")
  },
  {
    name: "other-languages-category-subcategory___en",
    path: "/other-languages/:category()/:subcategory()",
    meta: indexokw9koJ6d0FwnPxkCTqWLILFB9UGxuln_xzfdlzESTUMeta || {},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/other-languages/[category]/[subcategory]/index.vue")
  },
  {
    name: "stationary-and-gifts-category-subcategory___hu",
    path: "/hu/noteszek-es-ajandektargyak/:categorysubcategory?",
    meta: indexQbRsIMtwe8t7RtAhqHVl70hpN2jkahsxxVhDEfOX9QAMeta || {},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/stationary-and-gifts/[category]/[subcategory]/index.vue")
  },
  {
    name: "stationary-and-gifts-category-subcategory___en",
    path: "/stationary-and-gifts/:category()/:subcategory()",
    meta: indexQbRsIMtwe8t7RtAhqHVl70hpN2jkahsxxVhDEfOX9QAMeta || {},
    component: () => import("/codebuild/output/src863075979/src/storefront/pages/stationary-and-gifts/[category]/[subcategory]/index.vue")
  }
]